import { render } from "./EventLayout.vue?vue&type=template&id=34e1d190&ts=true"
import script from "./EventLayout.vue?vue&type=script&lang=ts"
export * from "./EventLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__